// @flow
export const CompanyRegisterLocale = {
  form: {
    header: [
      "Please fill and submit the form below to create your company account along with its management users for Envanterium Online.",
      "Aşağıdaki formu doldurarak firma hesabınızı oluşturabilir ve yönetici kullanıcı hesaplarını tanımlayabilirsiniz."
    ],
    form_unit: {
      title: ["Company Title", "Firma Adı"],
      email: ["Contact Email Address for Company", "Firma için İletişim Eposta Adresi"],
      phone: ["Contact Phone Number for Company", "Firma için İletişim Telefon Numarası"],
      address: ["Contact Address for Company Headquarters", "Firma Merkez İletişim Adresi"],
      city: ["City", "Şehir"],
      district: ["District", "Semt"],
      country: ["Country", "Ülke"],
      postal_code: ["Postal Code", "Posta Kodu"],
      district_no_results: ["No City Selected", "Seçili Şehir Bulunmuyor"],
      users_desc: [
        "Please enter email addresses for users that will control your company account.",
        "Lütfen firma hesabınızı yönetecek kullanıcıların eposta adreslerini girin."
      ],
      users: ["User Email Address", "Kullanıcı Eposta Adresi"],
      submit: ["Submit", "Onayla"]
    }
  },
  error: {
    header: [
      "An error occurred with your registration.",
      "Sisteme kaydınızı yaparken bir hatayla karşılaştık."
    ],
    content: [
        "There is a big chance that you submitted invalid information. Please check all the fields try again.",
        "Yanlış / eksik bilgilerle kaydolmaya çalıştınız. Lütfen bilgilerinizi kontrol edip tekrar deneyiniz."
    ],
    action: ["Return to Company Account Register Form", "Firma Hesap Oluşturma Formuna Geri Dön"]
  },
  completed: {
    header: ["We have successfully created your company account", "Firma hesabınızı başarıyla oluşturduk"],
    content: [
      "Users you listed will receive an email shortly to create their accounts. After that, these users can login to your company dashboard.",
      "Kayıt formunda belirttiğiniz kullanıcılara kısa bir süre içinde hesaplarını oluşturmak için eposta gönderilecektir. Sonrasında bu kullanıcılar firma paneline giriş yapabilirler."
    ]
  }
};



// WEBPACK FOOTER //
// ./src/Locales/PublicAccountPages/CompanyRegister.locale.js